import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Paper from "@material-ui/core/Paper";
import { Header } from "../../shared";
import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import { cookieKeys } from "../../services/Cookies";
import { CommonCss } from "../../services/CommonCss";
import clsx from "clsx";
import Checkbox from "@material-ui/core/Checkbox";
import { postRequest } from "../../services/ApiServices";
import { ToastSuccess, ToastError } from "../../services/ToastMsg";
import { LOADING } from '../../action';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  selectedClass: {
    "&:hover": {
      color: "#FF4717",
    },
    width: "120px",
    background: "#FF4717",
    border: "2px solid #FF4717",
    borderRadius: "6px",
    color: "#FFF",
  },
  unSelected: {
    width: "120px",
    border: "2px solid #FF4717",
    borderRadius: "6px",
    color: "#FF4717",
  },
  checkbox: {
    padding: 0,
  },
  textRegister: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default function SignUp() {
  const { innerWidth: width, innerHeight: height } = window;
  const classes = useStyles();
  const commonClasses = CommonCss();
  const history = useHistory();
  const [email, setEmail] = useState("");
  //const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [login, setLogin] = useState(true);
  const [innerHeight, setInnerHeight] = useState(height);
  const dispatch = useDispatch();

  useEffect(() => {}, []);

  const isSignUp = () => {
    dispatch({ type: LOADING, payload: true });
    if(firstName == ""){
      ToastError("First name is required");
      return false;
    }
    //if(lastName == ""){
      //ToastError("Last name is required");
      //return false;
    //}
    if(email == ""){
      ToastError("Email is required");
      return false;
    }
    /*if(email == "/\s/g" && email=='')
    {
      ToastError("Cant including blan");
      return false;
    }*/
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      "UserRegistration/register";
    const data = {
      firstname: firstName,
      //lastname: lastName,
      email: email,
    };
    postRequest(url, data)
      .then((res) => {
        ////console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          ToastSuccess(res.data.message);
          history.push("/sign-in");
        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ToastError(error.response.data.message);
      });
  };
  const handleTextChange = (value,type) =>{
    //1 check values is null | undefined
    if(value){
      // 2 remove the spacess in start & last
      var enteredValue = value.toString().trim();
      //3 check string have any specialcharacters
      var format = type == 'email' ? /[!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]+/ : /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
     
      var hasAnySpace = /\s/.test(value);
      var hasAnySpecialCharacters = format.test(enteredValue);
      if(hasAnySpecialCharacters || hasAnySpace){
        ToastError("Cannot enter special characters/space");
      }
      else{
        // if no have any special characters variable value set
        if(type=='firstName'){
          setFirstName(enteredValue);
        }
       if(type=='email'){
        setEmail(enteredValue);
       }
      }
    }else{
      if(type=='firstName'){
        setFirstName(value);
      }
      if(type=='email'){
        setEmail(value);
      }
    }
  }
  return (
    <Box overflow="hidden">
      <Header />
      <Box bgcolor="#1A1A31" height={innerHeight - 123 + "px"}>
        <Box className={commonClasses.navContainer} height={1}>
          <Box
            display="flex"
            className={commonClasses.alignItemsStretch}
            height={1}
          >
            <Box width={0.5}>
              <Box pt={3} width={0.6}>
                <Paper className="loginpg"
                  elevation={3}
                   
                >
                  <Box component="h1" mt={0} fontWeight="500">
                    Welcome to <br />
                    VPS Customer Portal
                  </Box>
                  <form
                    className={classes.form}
                    noValidate
                    style={login ? { display: "block" } : { display: "none" }}
                    id="loginForm"
                  >
                    <Box
                      component="span"
                      display="block"
                      fontSize={14}
                      mt={3}
                      fontWeight="bold"
                    >
                      First Name
                    </Box>
                    <TextField
                      style={{ marginTop: "10px" }}
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      value={firstName}
                      name="firstname"
                      placeholder="John"
                      onChange={(e) => handleTextChange(e.target.value,'firstName')}
                    />

                  { /* <Box
                      component="span"
                      display="block"
                      fontSize={14}
                      mt={3}
                      fontWeight="bold"
                    >
                      Last Name
                    </Box>
                    <TextField
                      style={{ marginTop: "10px" }}
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      value={lastName}
                      placeholder="Doe"
                      name="lastname"
                      onChange={(e) => setLastName(e.target.value)}
                  />*/}
                    <Box
                      component="span"
                      display="block"
                      fontSize={14}
                      mt={3}
                      fontWeight="bold"
                    >
                      Email Id
                    </Box>

                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      id="email"
                      value={email}
                      //label="Email Address"
                      name="email"
                      placeholder="johndoe@companyname.com"
                      autoFocus
                      onChange={(e) => handleTextChange(e.target.value,'email')}
                    />
                    <Box display="flex">
                      <Box fontWeight="400">Use company email/domain only</Box>
                    </Box>
                  </form>

                  <Box mt={3} display="flex">
                    <Box>
                      <ButtonGroup disableElevation>
                        <Button
                          className={classes.selectedClass}
                          onClick={() => isSignUp()}
                        >
                          Register
                        </Button>
                      </ButtonGroup>
                    </Box>
                    <Box pl={4}>
                      <Box component="p" my={0} fontWeight="bold">
                        Existing Customer?
                      </Box>
                      <Box component="p" my={0} fontWeight="bold">
                        <Box
                          component="a"
                          onClick={() => {
                            history.push("/sign-in");
                          }}
                          className={clsx(
                            classes.textRegister,
                            commonClasses.cursorPointer
                          )}
                          color="#FF4717"
                          mr={1}
                        >
                          Login
                        </Box>
                        here
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            </Box>
            <Box width={0.5}>
              <Box
                display="flex"
                justifyContent="flex-end"
                height={1}
                alignItems="flex-end"
              >
                <Box
                  component="img"
                  src={
                    process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                    "assets/images/arrows.png"
                  }
                  mb={16}
                  mr={5}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
